import React, { Component } from "react";
import RugAPI from "../../../api/rug";
import DropDown from "./dropdown";

export default class RugBrands extends Component {
  // this.props.selectedBrands.indexOf(brand.id) !== -1

  constructor(props) {
    super(props);
    this.state = {
      brands: [],
    };
  }

  loadBrands = () => {
    const api = new RugAPI();
    api.getRugBrands().then((response) => {
      if (response.success) {
        this.setState({ brands: response.data });
      }
    });
  };

  componentDidMount() {
    this.loadBrands();
  }

  render() {
    return (
      <div style={{ width: "32%" }}>
        <DropDown
          name={this.props.texts.brand}
          list={this.state.brands}
          engName="brands"
          selected={this.props.selectedBrands}
          changeHandler={this.props.changeHandler}
        />
      </div>
    );
  }
}
